import { blockCategories } from '../../categories';

export default function (editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType('section', {
        model: {
            defaults: {
                tagName: 'section',
                droppable: true,
                draggable: true,
                stylable: true,
                attributes: {
                    class: 'sio-section section',
                },
                components: [
                    {
                        tagName: 'div',
                        droppable: true,
                        classes: ['container', 'mx-auto'],
                    },
                ],
            },
            init() {
                let isRedirecting = false;
                this.listenTo(this.components(), 'add', (component, collection, options) => {
                    if (isRedirecting) {
                        return;
                    }
                    const componentClasses = component.getClasses();
                    const isContainer = Array.isArray(componentClasses) &&
                                       componentClasses.includes('container');
                    if (isContainer) {
                        return;
                    }
                    const parent = component.parent();
                    if (parent === this) {
                        const container = this.components().find(comp => {
                            const classes = comp.getClasses();
                            return Array.isArray(classes) && classes.includes('container');
                        });

                        if (container && container !== component) {
                            const sectionComponents = this.components();
                            const sectionIndex = sectionComponents.indexOf(component);
                            const containerComponents = container.components();
                            const containerLength = containerComponents.length;
                            let containerIndex = 0;
                            for (let i = 0; i < sectionIndex; i++) {
                                const comp = sectionComponents.at(i);
                                if (comp !== container) {
                                    containerIndex++;
                                }
                            }
                            const isAtEnd = sectionIndex === sectionComponents.length - 1;
                            const targetIndex = isAtEnd ? containerLength : containerIndex;
                            isRedirecting = true;
                            setTimeout(() => {
                                try {
                                    if (component.parent() === this) {
                                        component.remove({ silent: true });
                                        if (isAtEnd) {
                                            containerComponents.add(component);
                                        } else {
                                            containerComponents.add(component, { at: targetIndex });
                                        }
                                    }
                                } finally {
                                    isRedirecting = false;
                                }
                            }, 0);
                        }
                    }
                });
            },
        },
        view: {},
    });


    blockManager.add('section', {
        label: 'Abschnitt',
        category: blockCategories.basic,
        media: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z"></path>
        </svg>`,
        content: {
            type: 'section',
        },
    });
}
